import { useContext, useEffect, useState } from 'react';
import { SupervisorContext } from '@/contexts/SupervisorContext';
import { getRoutineStepLabels } from '@/utils/routineStepLabels';

/**
 * Om rutinens legobitar ska visa stegens namn i den vy som renderas nu.
 *
 * Exakt samma källordning som useTimerDisplay, och av samma skäl:
 *
 *  1. Handledarläge med vald brukare → BRUKARENS värde (currentClient), för då visar
 *     vyn brukarens dag. Utan detta hade handledaren sett sin egen inställning i
 *     förhandsvisningen och trott att valet inte gick igenom.
 *  2. Annars → det egna kontots värde, speglat i localStorage av AppContext. Spegeln
 *     läses live via 'storage' så att en ändring slår igenom utan omladdning.
 */
export const useRoutineStepLabels = (): boolean => {
  const [labels, setLabels] = useState<boolean>(getRoutineStepLabels);
  const { currentClient } = useContext(SupervisorContext);

  useEffect(() => {
    const handleStorageChange = () => setLabels(getRoutineStepLabels());

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  if (currentClient) return currentClient.routineStepLabels === true;
  return labels;
};
